import { useEffect, useState } from "react";

export default function useAppVersion() {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    fetch("/version.json")
      .then((res) => res.json())
      .then((data) => setVersion(data.version))
      .catch(() => setVersion(null));
  }, []);
console.log(`chk version`, version);

  return version;
}
